import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { RefreshCw, TrendingUp, Settings2, Maximize } from 'lucide-react';
export function RevampRepeat() {
  return <FeaturePageLayout hero={{
    badge: 'Step 7 of 7',
    h1: <>
            Revamp &{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-2256" data-mp="3pf24qll0jjb0">
              Repeat
            </span>
          </>,
    subtitle: 'Business evolves, and so should your AI. We continuously analyze performance data and refine agent behaviors to scale with your growth.'
  }} problem={{
    subtitle: 'The Stagnation Trap',
    cards: [{
      icon: <Settings2 className="w-6 h-6 text-teal" data-id="element-2257" data-mp="36rgmt5x4n6vi" />,
      title: 'Static Systems',
      desc: 'Traditional software implementations degrade over time as your business processes change and evolve.'
    }, {
      icon: <Maximize className="w-6 h-6 text-purple" data-id="element-2258" data-mp="33a9p18iv59dc" />,
      title: 'Scaling Bottlenecks',
      desc: 'What works for 100 customers might break when you scale to 1,000 without proper system adjustments.'
    }, {
      icon: <TrendingUp className="w-6 h-6 text-blue-400" data-id="element-2259" data-mp="2uby2pip14xqp" />,
      title: 'Missed Opportunities',
      desc: 'Failing to iterate means missing out on new AI capabilities and further optimization potential.'
    }]
  }} solution={{
    badge: 'The Evolution',
    title: 'Continuous Optimization',
    desc: 'Your AI infrastructure is a living system. We provide ongoing refinement to ensure it always operates at peak efficiency.',
    features: [{
      icon: <RefreshCw className="w-6 h-6 text-teal" data-id="element-2260" data-mp="21lfq9r2f1k0m" />,
      title: 'Iterative Refinement',
      desc: 'We use performance data to tweak prompts, adjust workflows, and improve agent accuracy over time.'
    }, {
      icon: <TrendingUp className="w-6 h-6 text-purple" data-id="element-2261" data-mp="1mh4koxgwdjdc" />,
      title: 'Scalable Growth',
      desc: 'As your business expands, we repeat the process to automate new departments and handle increased volume.'
    }]
  }} data-id="element-2255" data-mp="3uey8qktpnaqk" />;
}